module.exports = __webpack_public_path__ + "img/charcoal-kiln.e1729493.webp";